/**
 * Universal Animations
 ***/

var MDAllyAnimations = (function($) {
   
   	const controller = new ScrollMagic.Controller();
   	const EO = Elastic.easeOut.config;
   	const desktopOnly = [];
   	let nodeVideo;
   	let isMobile = false;

    const onInit = function() {

    	isMobile = ($('.mobile-detect').css('display') == 'block');

    	if( $('.node-garden').length ) initNodeGarden();
    	if( $('section.hero').length ) initHeroReveal();
    	if( $('section.image-pin').length ) initImagePinSections();
    	
    	buildFooterReveal();
    	buildRevealAnimations();
    	buildBoxRevealAnimations();
    	buildImageRevealAnimations();
    	buildStickyColumnAnimation();
    	buildQuoteBlockAnimation();

    	$(window).resize( handleWindowResize ).resize();
    }

    const onUpdate = function() {
    	handleWindowResize();
    }

    /**
     * Init Node Gardens
     ***/
    function initNodeGarden() {
    	nodeCanvas = $('.node-garden');
 
    	if( $('.node-garden video').length > 0 ) {
	    	nodeVideo = $('.node-garden video')[0];
	    	$(nodeVideo).data('isNodeVideo',true);
	    	nodeVideo.addEventListener('playing' , (e)=>{
	    		console.log( 'playing' );
	    		$(e.currentTarget).data('wasPlaying',true);
	    		$(e.currentTarget).data('isSuspended',false);
	    		$('.node-garden .poster').css('opacity',0);
	    	});
	    	nodeVideo.addEventListener('suspend', (e)=>{
	    		console.log( 'suspended' );
	    		if( !$(e.currentTarget).data('wasPlaying') ) {
	    			$(e.currentTarget).data('isSuspended',true);
			  		$('.node-garden .poster').css('opacity',1);
			  	}
			});
			nodeVideo.addEventListener('pause', (e)=>{
	    		console.log( 'paused' );
			  $('.node-garden .poster').css('opacity',1);
			});
			
	    	nodeVideo.src = ( isMobile ) ? $(nodeVideo).data('src-mobile') : $(nodeVideo).data('src-desktop');
	    	$(nodeVideo).data('srcIsMobile' , ( isMobile ) );
	    	nodeVideo.play();
	    }
    	/*if( !nodeCanvas.data('lib') ) 
    		nodeCanvas.data('onReady' , onNodeGardenLoaded );
    	else 
    		onNodeGardenLoaded();
    	*/
    }

    function onNodeGardenLoaded() {
    	const lib = nodeCanvas.data('lib');
    	const exportRoot = nodeCanvas.data('exportRoot');
    	exportRoot.onInit( $(nodeCanvas).data('amnt') , $(nodeCanvas).data('dist') , $(nodeCanvas).data('alpha') , $(nodeCanvas).data('alpha-bottom') , $(nodeCanvas).data('alpha-left') );

    	$(window).resize(()=>{
    		/*var w = $(nodeCanvas).width();
    		var h = $(nodeCanvas).height();
    		console.log( w +":"+ h );
    		lib.properties.width = w * 2;
    		lib.properties.height = h * 2;
    		exportRoot.orbs.x = (w * 2) * 0.85;*/
    	}).resize();
    }

    function buildFooterReveal() {

    	// footer reveal //
    	gsap.set( "footer.footer .inner" , {alpha:0.1 , yPercent:-95});
    	const footerReveal = new ScrollMagic.Scene({
				triggerElement: "footer.footer",
				triggerHook: "1",
				duration: $("footer.footer").outerHeight() - 30
			})
			.setTween( "footer.footer .inner" , {alpha:1 , yPercent:0} )
			.addTo(controller);
    }
 
    function buildRevealAnimations() {
    	$('h1.reveal, h2.reveal, h3.reveal, h4.reveal').each((i,el)=> {
    		const text01 = new SplitText( el , {type:'lines' , linesClass:'line' } );
    		$(el).find('.line').wrapInner('<div class="wrap"></div>');

    		const ani = gsap.from( $(el).find('.wrap') , 1.5 , {stagger:0.1, yPercent:150 , ease:EO(0.6,1)} );
    		const reveal = new ScrollMagic.Scene({
				triggerElement: el ,
				triggerHook: "0.8",
			})
			.setTween( ani )
			.addTo(controller);
    	});
    } 

    function buildBoxRevealAnimations() {
    	$('.box-reveal').each((i,el)=>{
    		let trigger = '0.4';
    		if( $(el).hasClass('trigger-80') ) trigger = '0.8';
    		if( $(el).hasClass('trigger-70') ) trigger = '0.7';
    		if( $(el).hasClass('trigger-60') ) trigger = '0.6';
    		if( $(el).hasClass('trigger-50') ) trigger = '0.5';
    		if( $(el).hasClass('trigger-40') ) trigger = '0.4';
    		if( $(el).hasClass('trigger-30') ) trigger = '0.3';
    		if( $(el).hasClass('trigger-20') ) trigger = '0.2';
    		if( $(el).hasClass('trigger-10') ) trigger = '0.1';

    		const ani = gsap.fromTo( el , 1 ,  
    			{clipPath:'polygon(7% 7%,93% 7%,93% 93%,7% 93%)'} , 
    			{clipPath:'polygon(0% 0%,100% 0%,100% 100%,0% 100%)' , ease:Power2.easeInOut } );
    		const boxreveal = new ScrollMagic.Scene({
				triggerElement: el ,
				triggerHook: trigger,
			})
			.setTween( ani )
			//.addIndicators({name:'box-reveal'})
			.addTo(controller);
    	});
    }
 
    function buildImageRevealAnimations() {
    	$('.img-reveal').each((i,el)=>{
    		const ani = gsap.fromTo( el , 1.5 ,  
    			{clipPath:'inset(100% 0% 0% 0%)'} , 
    			{clipPath:'inset(0% 0% 0% 0%)' , ease:Expo.easeOut , delay:(i*0.2) } );
    		const boxreveal = new ScrollMagic.Scene({
				triggerElement: el ,
				triggerHook: "0.9",
			})
			.setTween( ani )
			//.addIndicators({name:'img-reveal'})
			.addTo(controller);
    	});
    }

    function initHeroReveal() {

    	$('section.hero').each((i,el)=>{
    		const media = $(el).find('.hero-image');
    		if( media.length == 0 ) return false;
    		const ani = gsap.fromTo( media , 2 ,  
    			{clipPath:'polygon(7% 7%,93% 7%,93% 93%,7% 93%)'} , 
    			{clipPath:'polygon(0% 0%,100% 0%,100% 100%,0% 100%)' , ease:Expo.easeOut } );
    		const boxreveal = new ScrollMagic.Scene({
				triggerElement: el ,
				triggerHook: "0.6",
			})
			.setTween( ani )
			//.addIndicators({name:'img-reveal'})
			.addTo(controller);

    	});
    }

    function buildStickyColumnAnimation() {
    	
    	$('.sticky-column').each((i,el)=>{
    		//$(el).find('.wp-block-image.show-for-medium img, .wp-block-image.pin img').wrap('<div class="pan"></div>');

    		const sceneObj = {
    			name: 'sticky',
	    		el: el,
	    		trigger: {triggerElement: el , triggerHook:0.05 , duration:'70%'},
	    		gsap: null,
	    		pin : $(el).find('.wp-block-image.show-for-medium, .wp-block-image.pin')[0],
	    		scene: null,
	    		inited : false,
	    		desktopOnly: true
	    	}
	    	sceneObj.scene = addToController( sceneObj );

			const stickyInner = {
				name: 'stickyInner',
	    		el: 'section.impactful-partnership',
	    		trigger: {triggerElement: el , triggerHook:0.05 , duration:'100%'},
	    		gsap: gsap.fromTo( $(el).find('.wp-block-image.show-for-medium img, .wp-block-image.pin img') , {scale:1.05} , {transformOrigin:'50% 50%' , scale:1 , ease:'none'} ),
	    		pin : null,
	    		scene: null,
	    		inited : false,
	    		desktopOnly: false
	    	}
	    	stickyInner.scene = MDAllyAnimations.add( stickyInner );
    	});
    }

    function buildQuoteBlockAnimation() {
    	$('.quote-block').each((i,el)=>{
    		const quoteBubble = gsap.timeline();
    		quoteBubble.from( $(el).find('.quote-inner-bkgrnd') , 1 , {scale:"-=0.5" , transformOrigin:'50% 50%' , alpha:0 , ease:EO(0.8,1) } , 0 );
    		quoteBubble.from( $(el).find('.quote-inner-ring') , 1 , {scale:"-=0.5" , transformOrigin:'50% 50%' , alpha:0 , ease:EO(0.8,1) } , 0 ); 
    		quoteBubble.from( $(el).find('.quote-icon') , 1 , {scale:"-=0.5" , transformOrigin:'50% 50%' , alpha:0 , ease:EO(0.8,1) } , 0.2 ); 
    		quoteBubble.from( $(el).find('.quote-outer-ring') , 1 , {scale:"-=0.5" , transformOrigin:'50% 50%' , alpha:0 , ease:EO(0.8,1) } , 0.8 ); 

    		const quoteBubbleScene = {
    			name: 'quoteBubbleScene',
	    		el: $(el).find('.quote-container-border'),
	    		trigger: {triggerElement: el , triggerHook:0.7 },
	    		gsap: quoteBubble , 
	    		pin : null,
	    		scene: null,
	    		inited : false,
	    		desktopOnly: true
	    	}
	    	quoteBubbleScene.scene = addToController( quoteBubbleScene );

	    	const quoteText = {
    			name: 'quoteText',
	    		el: $(el).find('.copy-set'),
	    		trigger: {triggerElement: el , triggerHook:0.8 , duration:'200%' , offset:'-100%'},
	    		gsap: gsap.fromTo(  $(el).find('.copy-set') , 2 , {yPercent:25} , {yPercent:-25} ),
	    		pin : null,
	    		scene: null,
	    		inited : false,
	    		desktopOnly: true
	    	}
	    	quoteText.scene = addToController( quoteText );
	    	
	    	const quoteBubbleMove = {
    			name: 'quoteBubbleMove',
	    		el: $(el).find('.copy-set'),
	    		trigger: {triggerElement: el , triggerHook:0.8 , duration:'200%' , offset:'-100%'},
	    		gsap: gsap.fromTo(  $(el).find('.quote-image-container') , 2 , {yPercent:-15} , {yPercent:15} ),
	    		pin : null,
	    		scene: null,
	    		inited : false,
	    		desktopOnly: true
	    	}
	    	quoteBubbleMove.scene = addToController( quoteBubbleMove );
			
    	});
    }

    function initImagePinSections() {

    }

    function addToController( sceneObj ) {
    	if( !sceneObj.reverse ) sceneObj.reverse = true;

    	//console.log( 'adding new scene' );
    	if( sceneObj.inited ) return sceneObj.scene;
    	const scene = new ScrollMagic.Scene( sceneObj.trigger );
    	if( sceneObj.pin ) scene.setPin( sceneObj.pin );
    	if( sceneObj.gsap ) scene.setTween( sceneObj.gsap );
    	if( sceneObj.funct ) {
    		sceneObj.gsap = sceneObj.funct();
    		scene.setTween( sceneObj.gsap );
    	}
    	//scene.addIndicators({name: sceneObj.name })
    	scene.reverse(sceneObj.reverse);
    	scene.addTo( controller );

    	sceneObj.inited = true;

    	if( sceneObj.desktopOnly ) {
    		desktopOnly.push( sceneObj );
    	}

    	return scene;
    }

    function handleWindowResize() {
  		
  		isMobile = ($('.mobile-detect').css('display') == 'block');

    	for( let i = 0 ; i < desktopOnly.length ; i++ ) {
	    	if( $('.mobile-detect').css('display') == 'block' ) {
	    		for( let i = 0 ; i < desktopOnly.length ; i++ ) {
	    			if(desktopOnly[i].gsap) {
	    				const targets = desktopOnly[i].gsap._targets;
	    				desktopOnly[i].gsap.progress(1);
	    				desktopOnly[i].gsap.kill();
						if(targets !== undefined && targets.length > 0){
							for( let i = 0 ; i < targets.length ; i++ ) {
								gsap.set(targets[i], {clearProps:"all"});
							}
						}
	    			}
	    			if(desktopOnly[i].scene) desktopOnly[i].scene.destroy(true);
	    			desktopOnly[i].inited = false;
	    		}
	    	} else {
	    		for( let i = 0 ; i < desktopOnly.length ; i++ ) {
	    			desktopOnly[i].scene = addToController( desktopOnly[i] );
	    		}
	    	}
	    }

	    if( nodeVideo ) {
	    	if( isMobile ) {
	    		if( !$(nodeVideo).data('srcIsMobile') ) {
	    			nodeVideo.src = $(nodeVideo).data('src-mobile');
	    			nodeVideo.play();
	    			$(nodeVideo).data('srcIsMobile' , true);
	    		}
	    	} else {
	    		if( $(nodeVideo).data('srcIsMobile') ) {
	    			nodeVideo.src = $(nodeVideo).data('src-desktop');
	    			nodeVideo.play();
	    			$(nodeVideo).data('srcIsMobile' , false);
	    		}
	    	}

	    }

    }

    return {
    	init: onInit,
    	add : addToController,
    	update : onUpdate
    };

})(jQuery);